<style>
@import 'assets/css/common.css';
#app {
  height: 100%;
  width: 100%;
}
#app > div {
  min-height: 100%;
}
</style>
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import MessageBox from '@/assets/js/message-box.js';
//jknNuOjmWsmLcWuVDH44hHj3uUT2EFKZc9/eYt9wlno=
export default {
  data () {
    return {
      deviceInfo: {},
    };
  },
  beforeCreate () { },
  created () {
    window.saveDeviceInfo = this.saveDeviceInfo;
  },
  mounted () {
    // localStorage.setItem("token", 'xbs8DC8didYy7h32hN0ZHzW9dph8hualv5N/RSdaYBFV5t0KAJ6zoUSnOCTJqqmO2Rpx0jzlF2+VGsENME1Kyw==');
    this.getDeviceInfo();
    window.saveDeviceInfo = this.saveDeviceInfo;
  },
  beforeDestroy () { },
  computed: {},
  methods: {
    getDeviceInfo () {
      try {
        window.webkit.messageHandlers.getDeviceInfo.postMessage(""); //ios
      } catch (err) {
        window.AppJs.getDeviceInfo(); //android
      }
    },
    saveDeviceInfo (str) {
      this.deviceInfo = JSON.parse(str);
      localStorage.setItem("token", this.deviceInfo.token);
      localStorage.setItem("customerId", this.deviceInfo.customerId);
      localStorage.setItem("phone", this.deviceInfo.phone);
      localStorage.setItem("udid", this.deviceInfo.udid);
      localStorage.setItem("appVersion", this.deviceInfo.appVersion);
      localStorage.setItem(
        "appMarketChannel",
        this.deviceInfo.appMarketChannel
      );
      // localStorage.setItem("deviceInfo", this.deviceInfo);
      localStorage.setItem("os", this.deviceInfo.os);
      localStorage.setItem("packageName", this.deviceInfo.packageName);
    },
  },
};
</script>
